import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BussinessRegAppService } from 'app/service/business-reg-app/bussiness-reg-app.service';
import { TRCAppForm } from 'app/shared/models/tRCAppForm.model';

@Component({
  selector: 'jhi-eappreg-confirm-letter',
  templateUrl: './eappreg-confirm-letter.component.html',
  styleUrls: ['./eappreg-confirm-letter.component.scss']
})
export class EappregConfirmLetterComponent  implements OnInit {

  trcAppForm = new TRCAppForm() ;
  trcQBAStreetType : any ;
  trcNextSteps : any ;
  
  constructor() {/*empty*/}

  ngOnInit(): void {
    this.trcAppForm = JSON.parse(sessionStorage.getItem("TRCAppForm") ?? "") ;
    this.trcQBAStreetType = sessionStorage.getItem("TRCqBAStreetType")?? "" ;
    this.trcNextSteps = JSON.parse(sessionStorage.getItem("TRCNextSteps") ?? "") ;
  }
  

  get sessionStorage() : any {
    return sessionStorage ;
  }

 

}
